
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'react-bootstrap';
import './GroupPlantsPage.css';
import {useLoading} from '../../components/LoadingProvider';

import { FaAngleLeft } from 'react-icons/fa';

import { getPlantsByGroup } from '../../services/plants/publicPlantsService';
import { left } from '@popperjs/core';


const GroupPlantsPage = () => {
  const { groupId } = useParams();
  const [plants, setPlants] = useState([]);
  const navigate = useNavigate();
  const { t ,i18n} = useTranslation();

  const { showLoading, hideLoading, toast } = useLoading();
  const BASE_URL = process.env.REACT_APP_BASE_URL;





  useEffect(() => {
   
    showLoading();


    getPlantsByGroup(groupId)
    .then(list=>{
          console.log('DATA ::: ',list)

      const mapped = list.map(e=>({
             
          id: e._id,
          name: e.name,
          latinName: e.latinName,
          groupName : e.group.name,
          description: e.description,
          image: (e.images || []).length > 0 ? BASE_URL+e.images[0].url :  "https://picsum.photos/400?random=8239748"
        
      }));
        setPlants(mapped);

    })
    .catch(err=>{
         console.log('ERROR ::: ',err)
          toast.error('Error on loading Plants!')
    })
    .finally(()=>{
        hideLoading()
    });
 

  }, [groupId , i18n.language]);

  const handlePlantClick = (plantId) => {
    navigate(`/plants/details/${plantId}`);
  };

  const handleBack = () => {
    navigate(-1); // یا مسیر خاص مثل: navigate('/groups');
  };

  return (
    <div className="container mt-4">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h2 className="mb-0">{t('botany.groupPlantsTitle')}</h2>
      <button className="btn btn-outline-secondary rounded-pill px-3" onClick={handleBack}>
        <FaAngleLeft/>
         {t('common.back')}
      </button>
    </div>

    <div className="row">
      {plants.map((plant) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={plant.id}>
          <Card className="plant-card h-100" onClick={() => handlePlantClick(plant.id)} style={{ cursor: 'pointer' }}>
            <Card.Img variant="top" src={plant.image} alt={plant.name} style={{ objectFit: 'cover', height: '180px' }} />
            <CardBody>
              <h5 className="plant-title">{plant.name}</h5>
              <h6 className="plant-title" title='Latin Title' style={{direction:'ltr', textAlign:left}}>{plant.latinName}</h6>
              <p className="plant-summary text-muted">{plant.groupName}</p>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  </div>

    // <div className="container mt-4">
    //   <h2 className="mb-4">{t('botany.groupPlantsTitle')}</h2>
    //   <div className="row">
    //     {plants.map((plant) => (
    //       <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={plant.id}>
    //         <Card className="plant-card" onClick={() => handlePlantClick(plant.id)}>
    //           <Card.Img variant="top" src={plant.image} alt={plant.name} />
    //           <CardBody>
    //             <h5 className="plant-title">{plant.name}</h5>
    //             <p className="plant-summary">{plant.description}</p>
    //           </CardBody>
    //         </Card>
    //       </div>
    //     ))}
    //   </div>
    // </div>
  );
};

export default GroupPlantsPage;
